module.exports = __webpack_public_path__ + "img/11.10e1a6d1.png";